import React from 'react';
import { AiOutlineShopping, AiOutlineFileText, AiOutlineArrowLeft } from "react-icons/ai";
import Header from '../components/header';
import { withRouter } from '../components/withRouter';

class AboutApp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: '',
      password: '',
      error: '',
      isLoading: false
    };
  };

  backAction = () => {
    this.props.navigate('/main')
  };

  render() {
    return (
      <div className='aboutPage'>
        <Header backAction={this.backAction} back={<AiOutlineArrowLeft />} pageName={'О приложении'}/>
        <h2>Digitalkassir</h2>
        <p>Приложение для приема платежей через ваш интернет-эквайринг и автоматической фискализацией по 54-ФЗ.</p>
        <br/>
        <h3>Что мы предлагаем:</h3>
        <ul style={{listStyleType: 'none'}}>
          <li>✔ Прием платежей – поддержка ведущих банков и платежных систем.</li>
          <li>✔ Фискализация чеков – полное соответствие требованиям законодательства.</li>
          <li>✔ Простота подключения – настройка за несколько минут.</li>
          <li>✔ Удобный интерфейс – интуитивно понятное управление.</li>
        </ul>
        <br/>
        <h3>Возможности</h3>
        <p>В данный момент в приложении доступно 2 раздела - "Продажи" и "Шаблоны"</p>
        <br/>
        <h4>Продажи</h4>
        <p>Здесь вы можете видеть список продаж по вашей кассей, просматривать чеки, делать возврат и создавать новые продажи, по которым можно принять оплату или фискализировать уже произведенный платеж</p>
        <br/>
        <h4>Шаблоны</h4>
        <p>Этот раздел сделан для легкости в работе с вашими клиентами прямо не переходя в приложение</p>
        <p>Создание шаблона происходит всего в несколько шагов:</p>
        <ul style={{listStyleType: 'none'}}>
          <li>1) В разделе "Шаблоны" нажмите "Добавить шаблон"</li>
          <li>2) Заполните данные о товарах и если нужно скорректируйте "Данные о продаже" нажав кнопку "Изменить настройки"</li>
          <li>3) Выберите нужный сервис для приема оплаты, либо поставьте пункт "Не выбрано, пробить чек" только для фискализации</li>
          <li>4) Нажмите сохранить</li>
          <li>5) Введите название шаблона и подтвердите</li>
        </ul>
        <p>Теперь вы можете использовать этот шаблон не выходя из диалога с вашим клиентом</p>
        <p>Просто введите @ и выберите бота в открывшемся меню или @digitalkassir_bot в чате и добавьте почту или номер телефона (без +7 или 8 в начале) клиента</p>
        <p style={{padding: '5px 10px', background: 'var(--gray)', borderRadius: 12}}>Например: @digitalkassir_bot test@mail.ru или @digitalkassir_bot 9998887766</p>
        <p>В открывшемся меню выберите шаблон и вы отправите сообщение от бота прямо в чат с клиентом</p>
        <p>Сообщение содержит итоговую сумму и контакт клиента, который вы ввели</p>
        <p>После чего нажмите кнопку "Подтвердить" и сообщение замениться ссылкой на чек или на оплату</p>
      </div>
    );
  }
}

export default withRouter(AboutApp);